import style from './style.module.scss';
import Interstitial from '../../assets/images/interstitials_update_gmc_2026.jpg';
import XMark from '../../assets/icons/xmark.svg';
import {useEffect, useRef, useState} from "preact/hooks";
import {i18nService} from "../../services/i18nService.jsx";

const FailureWarning = () => {
  const [showGmcFailureErr, setShowGmcFailureErr] = useState(true);
  const dialogRef = useRef(null);

  function openPopup() {
    document.querySelector('#content-wrapper').setAttribute('inert', '');
    document.querySelector('.site-header')?.setAttribute('inert', '');
    document.querySelector('#footer')?.setAttribute('inert', '');
    window.document.documentElement.style.overflow = "hidden";
  }

  function closePopup() {
    document.querySelector('#content-wrapper').removeAttribute('inert');
    document.querySelector('.site-header')?.removeAttribute('inert');
    document.querySelector('#footer')?.removeAttribute('inert');
    window.document.documentElement.style.overflow = "";
  }

  useEffect(() => {
    if (showGmcFailureErr && dialogRef.current) {
      dialogRef.current.focus();
    }

    if (showGmcFailureErr) {
      openPopup()
    } else {
      closePopup()
    }

    return () => {
      closePopup()
    };
  }, [showGmcFailureErr]);


  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setShowGmcFailureErr(false);
      }
    };
    const checkCloseTarget = (event) => {
      if (event.target === event.currentTarget) {
        setShowGmcFailureErr(false)
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    document.querySelector('#gmc-failure-modal').addEventListener("click", checkCloseTarget);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.querySelector('#gmc-failure-modal').removeEventListener("click", checkCloseTarget);
    };
  }, []);

  function handleClose() {
    setShowGmcFailureErr(false);
  }

  if (!showGmcFailureErr) return null;

  return (
    <div
      id="gmc-failure-modal"
      className={style.background}
    >
      <div
        id="dialog"
        className={style.container}
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
      >
        <h2 id={'dialogTitle'} className={style.srOnly} aria-hidden={true}>
          {i18nService.translate('loyalty_update_interstitial_title')}
        </h2>

        <div className={style.content}>
          <img
            id="image"
            className={style.img}
            src={Interstitial}
            alt={i18nService.translate('loyalty_update_interstitial_title')}
            tabIndex={0}
          />

          <p className={style.gmcText}>
            {i18nService.translate('loyalty_update_interstitial_text')}
          </p>

          <div className={style.buttonWrapper}>
            <ny-button buttonType={'high-width-button'} actionType={'primary'} onClick={handleClose}>
              <span slot={'buttonLabel'}>{i18nService.translate('Ok')}</span>
            </ny-button>
          </div>
        </div>

        <button
          className={style.closeBtn}
          aria-label="Fenster schließen"
          onClick={handleClose}
        >
          <img
            alt="close"
            className={style.closeIcon}
            src={XMark}
            aria-hidden={true}
          />
        </button>
      </div>
    </div>
  );
};

export default FailureWarning;
